
/* styles */
require("!!../../../node_modules/_extract-text-webpack-plugin@1.0.1@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/style-rewriter?id=data-v-e3d1ed8c&scoped=true!less-loader?sourceMap!../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/selector?type=styles&index=0!./page-demo.vue")

var Component = require("!../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/selector?type=script&index=0!./page-demo.vue"),
  /* template */
  require("!!../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/template-compiler?id=data-v-e3d1ed8c!../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/selector?type=template&index=0!./page-demo.vue"),
  /* scopeId */
  "data-v-e3d1ed8c",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/demo/page-demo.vue
// module id = 648
// module chunks = 1